/* eslint-disable */
// This file is automatically generated and should not be edited directly.
// Please edit the corresponding SVG file

import React from 'react';

const MoneyBag = (props: any) => (
<svg {...props}   viewBox="0 0 15 18" fill="inherit" stroke="none" xmlns="http://www.w3.org/2000/svg">
<g id="Frame 2028">
<path id="Union" fillRule="evenodd" clipRule="evenodd" d="M6.95819 4.00537C5.18411 4.00537 3.5623 3.00303 2.76892 1.41624L2.63042 1.13923C2.57843 1.03554 2.56994 0.915456 2.60655 0.805327C2.64331 0.695197 2.72225 0.604251 2.82593 0.552409C4.71259 -0.389836 5.73598 0.0654539 6.72611 0.508034C7.71805 0.950611 8.65603 1.36654 10.7324 0.53791C10.901 0.470104 11.0938 0.513747 11.2169 0.647309C11.34 0.781013 11.3674 0.976963 11.286 1.13923L11.1474 1.41638C10.354 3.00309 8.73221 4.00537 6.95819 4.00537ZM10.0685 4.87825L10.0686 4.87841L10.0687 4.87852C13.5141 9.1521 15.0194 13.3874 13.8983 15.8251C13.4421 16.8168 12.3229 18 9.58462 18H4.33588C1.91843 18 0.870296 16.8246 0.416581 15.8387C-0.64025 13.54 0.358885 9.83238 2.90151 6.16276C3.47742 5.33159 4.44601 4.87825 5.45719 4.87825H10.0685Z" fill="inherit"/>
</g>
</svg>
);

export default MoneyBag;